<div class="wrapper">
    <button mat-icon-button class="dialog-cancel-btn" (click)="close(false)">
        <mat-icon>close</mat-icon>
    </button>
    <h2>{{ "inputs.add_son" | translate}}:</h2>
    <p >{{ "inputs.add_son_txt" | translate}}</p>
    <div [formGroup]="idForm">
        <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>ID*</mat-label>
          <input matInput [formControlName]="'id'">
        </mat-form-field>
    </div>
    <div class="actions">
        <button mat-flat-button class="dialog-confirm-btn" [disabled]="!idForm.valid" (click)="addSon()">
            Confirmar
        </button>
    </div>
</div>